module.exports = __webpack_public_path__ + "files/cdd44c0804a255c9337b983692e18f06.png";